import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import AuthLayout from "../views/layouts/auth-layout.vue";
import TestLayout from "../views/layouts/test-layout.vue";

// Static
import HomePage from "../views/home";
// import EmployeApprove from "../views/home/employeonleave.vue";

// Auth
import LoginPage from "../views/auth/login.vue";

// Companies
import CompaniesPage from "../views/companies/index.vue";
import CompanyCreatePage from "../views/companies/create.vue";
import CompanyIdPage from "../views/companies/id.vue";

// users
import UsersPage from "../views/users/index.vue";
import UserCreatePage from "../views/users/create.vue";
import UserIdPage from "../views/users/id.vue";
// import UsersUploadPage from "../views/users/upload.vue";

//profile
import ProfilePage from "../views/profile/profile.vue";
import ProfileIndex from "../views/profile/profileindex.vue";

// Values
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// units
import UnitsPage from "@/views/units/index.vue";
import UnitsCreatePage from "@/views/units/create.vue";
import UnitsIdPage from "@/views/units/id.vue";
import DatasPage from "@/views/units/data.vue";

// ValueLists
import ValueLists from "@/views/value-lists/index.vue";
import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

//organizations
import OrganizationsPage from "@/views/organizations/index.vue";

//permissions
import PermissionPage from "@/views/permissions/index.vue";

//head pump sizes
import HeadPumpSizesPage from "@/views/head-pump-sizes/index.vue";
import HeadPumpSizeCreatePage from "@/views/head-pump-sizes/create.vue";
import HeadPumpSizeIdPage from "@/views/head-pump-sizes/id.vue";

//redis monitor
import RedisMonitorPage from "@/views/redis-monitor/index.vue";



const routes = [
  // AuthLayout
  {
    path: "/auth",
    name: "AuthLayout",
    component: AuthLayout,
    children: [{
      path: "/home",
      name: "HomePage",
      component: HomePage,
    },
    // Comapnies
    {
      path: "/companies",
      name: "CompaniesPage",
      component: CompaniesPage,
    },
    {
      path: "/companies/create",
      name: "CompanyCreatePage",
      component: CompanyCreatePage,
    },
    {
      path: "/companies/:companyId",
      name: "CompanyIdPage",
      component: CompanyIdPage,
    },
    // Users
    {
      path: "/users",
      name: "UsersPage",
      component: UsersPage,
    },
    {
      path: "/users/create",
      name: "UserCreatePage",
      component: UserCreatePage,
    },
    // {
    //   path: "/users/upload",
    //   name: "UsersUploadPage",
    //   component: UsersUploadPage,
    // },
    {
      path: "/users/:userId",
      name: "UserIdPage",
      component: UserIdPage,
    },
    // // admins
    // {
    //   path: "/admins",
    //   name: "AdminsPage",
    //   component: AdminsPage,
    // },
    // {
    //   path: "/admins/create",
    //   name: "AdminsCreatePage",
    //   component: AdminsCreatePage,
    // },
    // {
    //   path: "/admins/:adminId",
    //   name: "AdminsIdPage",
    //   component: AdminsIdPage,
    // },
    //sub-vendors
    // {
    //   path: "/sub-vendors",
    //   name: "SubVendorsPage",
    //   component: SubVendorsPage,
    // },
    // {
    //   path: "/sub-vendors/create",
    //   name: "SubVendorsCreatePage",
    //   component: SubVendorsCreatePage,
    // },
    // {
    //   path: "/sub-vendors/:vendorId",
    //   name: "SubVendorsIdPage",
    //   component: SubVendorsIdPage,
    // },
    //units
    {
      path: "/units",
      name: "UnitsPage",
      component: UnitsPage,
    },
    {
      path: "/units/create",
      name: "UnitsCreatePage",
      component: UnitsCreatePage,
    },
    {
      path: "/units/:unitId",
      name: "UnitsIdPage",
      component: UnitsIdPage,
    },
    {
      path: "/datas/:unitId",
      name: "DatasPage",
      component: DatasPage,
    },
    //profile
    {
      path: "/profile/:userId",
      name: "ProfilePage",
      component: ProfilePage,
    },
    {
      path: "/profile",
      name: "ProfileIndex",
      component: ProfileIndex,
    },
    //organization
    {
      path: "/settings",
      name: "OrganizationsPage",
      component: OrganizationsPage,
    },

    // Values
    {
      path: "/values",
      name: "Values",
      component: Values,
    },
    {
      path: "/values/create",
      name: "ValueCreate",
      component: ValueCreate,
    },
    {
      path: "/values/:valueId",
      name: "ValueId",
      component: ValueId,
    },
    // ValueLists
    {
      path: "/value-lists",
      name: "ValueLists",
      component: ValueLists,
    },
    {
      path: "/value-lists/upload",
      name: "ValueListUpload",
      component: ValueListUpload,
    },
    {
      path: "/value-lists/create",
      name: "ValueListCreate",
      component: ValueListCreate,
    },
    {
      path: "/value-lists/:valueListId",
      name: "ValueListId",
      component: ValueListId,
    },
    {
      path: "/test-layout",
      name: "TestLayout",
      component: TestLayout
    },
    //permissions
    {
      path: "/permissions",
      name: "PermissionPage",
      component: PermissionPage
    },
    //head pump sizes
    {
      path: "/head-pump-sizes",
      name: "HeadPumpSizesPage",
      component: HeadPumpSizesPage,
    },
    {
      path: "/head-pump-sizes/create",
      name: "HeadPumpSizeCreatePage",
      component: HeadPumpSizeCreatePage,
    },
    {
      path: "/head-pump-sizes/:headPumpSizeId",
      name: "HeadPumpSizeIdPage",
      component: HeadPumpSizeIdPage,
    },
    {
      path: "/redis-monitor",
      name: "RedisMonitorPage",
      component: RedisMonitorPage,
    },
    ],
  },

  // UnAuthLayout
  {
    path: "/unauth",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  if (
    to.name === "LoginPage") {
    if (store.getters["auth/authenticated"]) {
      const roleName = store.getters["auth/roleName"];
      if (roleName == 'Admin' || roleName == 'Sub Vendor') {
        return next({
          name: "UsersPage",
        });
      }else if(roleName == 'User'){
        return next({
          name: "UnitsPage",
        });
      }
       else {
        return next({
          name: "OrganizationsPage",
        });
      }
    }
    next();
  } else if (!store.getters["auth/authenticated"]) {
    return next({
      name: "LoginPage",
    });
  } else if (to.name === null) {
    return next({
      name: "HomePage",
    });
  }
  next();
});

export default router;
